var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right-fix-draw-wrapper"},[_c('div',{staticClass:"draw-mask",on:{"click":_vm.closeMobileSideBar}}),_c('div',{staticClass:"draw-page"},[_c('el-scrollbar',{staticClass:"draw-page-scrollbar"},[_vm._t("default")],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }